import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExecutionResult, LcsApiService } from '@lcs/shared/api';
import { PhoneNumberInput } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { PhoneNumberDetailSaveModel } from '../models/phone-number-detail-save.model';
import { SavePhoneNumber, SavePhoneNumberVariables } from '../queries/generated/SavePhoneNumber';
import { SavePhoneNumberMutation } from '../queries/save-phone-number.graphql';

@Injectable({ providedIn: 'root' })
export class PhoneNumberDetailApiService {
   constructor(private apiService: LcsApiService, private httpClient: HttpClient) {}

   save(
      phoneNumberDetail: PhoneNumberDetailSaveModel,
      fields: (keyof PhoneNumberInput)[]
   ): Observable<ExecutionResult<SavePhoneNumber>> {
      return this.apiService.query<SavePhoneNumber, SavePhoneNumberVariables>({
         query: SavePhoneNumberMutation,
         variables: {
            phoneNumber: {
               ...phoneNumberDetail,
               fields: fields,
            },
         },
      });
   }

   ReleaseFromAccount(phoneNumberId: any, Delete: boolean): Observable<any> {
      return this.httpClient.get(
         this.apiService.apiUrl + '/PhoneNumbers/ReleasePhoneNumber?phoneNumberId=' + phoneNumberId + '&delete=' + Delete
      );
   }
}
